<template>
    <div class="notice">
      <div>
        <span class="back" @click="routerTo('/mpage/m_notice')">
          <img src="../img/arrow.png" alt=""> 首页
        </span>
      </div>
      <div class="content">
        <h2 class="title">
          短视频作品规则
        </h2>
        <p>
          1.志愿者、中文教师在参加选拔、培训以及任教期间拍摄的或以他人视角拍摄的与志愿者有关的视频作品；
        </p>
        <p>
          2.根据视频拍摄的时间及地点，正确录入相关文字信息，同时对视频做简单文字摘要。视频题目字数限制在50字以内，描述限制在150字以内；每位用户可最多上传10段视频。
        </p>
        <p>
          3.视频中不得带有黄、赌、毒及任何带有政治色彩的镜头。
        </p>
        <p>
          4.视频拍摄及剪辑格式及要求：
        </p>
        <p>
          视频拍摄工具不限，可以使用手机、专业相机或特种摄像机，拍摄完成的内容可进行剪辑、调色等相关处理。
        </p>
        <p>视频时长：3-5分钟</p>
        <p>画幅宽高比：16:9或9：:16</p>
        <p>建议分辨率：720x1280像素或1920x1080像素（16:9）</p>
        <p class="mgl">1280x720像素或1080x1920像素（9:16）</p>
        <p>视频帧数：25帧</p>
        <p>视频文件质量大小：1GB以内（如视频过大请用相关软件进行转码、压缩处理）</p>
        <p>视频格式：建议使用MP4（或其他主流视频格式文件） 视频编码建议使用H.264编码器 比特率建议控制在 1200kb/秒以内。 如视频中语言为外文，请在视频画面中添加中文字幕或在简介中录入中文内容。可通过手机或电脑端进行成片视频源文件提交。</p>
      </div>
    </div>
</template>

<script>
export default {
    name: 'notice',
    data: function () {
        return {
            
        }
    },
    methods: {
      routerTo(path) {
        this.$router.push(path)
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.notice {
    width: 100%;
    margin: 0.29rem auto 0.45rem;
    text-align: center;
    font-size: 20px;
    text-align: left;
    .back {
      font-size: 0.36rem;
      color: #0b0b0b;
      font-weight: bold;
      cursor: pointer;
      img {
        vertical-align: middle;
        width: 0.26rem;
        margin-top: -0.1rem;
        margin-left: 0.45rem;
      }
    }
    .content {
      width: calc(100% - 0.9rem);
      background-color: #fff;
      padding: 0 0.45rem 0.6rem;
      box-sizing: border-box;
      margin: 0 0.45rem;
      text-align: center;
      margin-top: 0.8rem;
      &:last-child {
        padding-bottom: 5.6rem;
      }
      .title {
        position: relative;
        top: -0.45rem;
        width: 40%;
        height: 0.9rem;
        line-height: 0.88rem;
        margin: auto;
        background-image: linear-gradient(0deg, 
          #746bef 0%, 
          #728bf9 100%);
        border-radius: 0.44rem;
        text-align: center;
        font-size: 0.6rem;
        color: #fff;
        font-weight: bold;
        &:before {
          position: absolute;
          left: -1.1rem;
          top: 0.2rem;
          content: '';
          display: inline-block;
          width: 0.8rem;
          height: 0.8rem;
          background-image: url(../img/left.png);
          background-size: contain;
          background-repeat: no-repeat;
        }
        &:after {
          position: absolute;
          right: -1.2rem;
          top: 0.2rem;
          content: '';
          display: inline-block;
          width: 0.8rem;
          height: 0.8rem;
          background-image: url(../img/right.png);
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
      p {
        text-align: left;
        font-size: 0.45rem;
        color: #0b2ab0;
        line-height: 1.6;
        text-indent: 2em;
      }
      .p_left {
        text-indent: 0;
      }
      h2 {
        font-size: 0.45rem;
        font-weight: bold;
        color: #0b2ab0;
        text-align: left;
        margin-top: 0.4rem;
      }
      h3 {
        font-size: 0.45rem;
        line-height: 1.4;
        color: #0b2ab0;
        text-align: left;
        margin-top: 0.35rem;
        text-indent: 1em;
      }
    }
    .link {
      position: relative;
      margin-top: 0.73rem;
      &:before {
        content: '';
        position: absolute;
        left: 1rem;
        top: -1.2rem;
        background-image: url(../img/link.png);
        background-repeat: no-repeat;
        background-size: 100%;
        width: 0.32rem;
        height: 1.6rem;
      }
      &:after {
        content: '';
        position: absolute;
        right: 1rem;
        top: -1.2rem;
        background-image: url(../img/link.png);
        background-repeat: no-repeat;
        background-size: 100%;
        width: 0.32rem;
        height: 1.6rem;
      }
    }
}
</style>
